import React from 'react';
import { Icon } from './Icon.js';
export const IconHouseSparkle2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M13.5625 14.5625L16 13.4545V12.5455L13.5625 11.4375L12.4545 9H11.5455L10.4375 11.4375L8 12.5455L8 13.4545L10.4375 14.5625L11.5455 17H12H12.4545L13.5625 14.5625Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M12 2L2 9.5V10.5L4 11V21H20V11L22 10.5V9.5L12 2Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconHouseSparkle2.js.map